import api from '../library/axios';
import config from '../config';

export default {
  get_steps({ workspace_id }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/list`,
    });
  },
  update_steps({ workspace_id, data }) {
    return api({
      method: 'post',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/update`,
      data,
    });
  },
  delete_step({ workspace_id, key, form }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/delete`,
      data: {
        step_key: key,
        form,
      },
    });
  },
  get_leads_all({ workspace_id, step_key }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/leads`,
      params: {
        step_key,
      },
    });
  },
  get_fields({ workspace_id }, query) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/fields/list`,
      params: query,
    });
  },
  create_fields({ workspace_id, data }) {
    return api({
      method: 'post',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/fields`,
      data,
    });
  },
  delete_fields({ workspace_id, field_id }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/${field_id}/fields/delete`,
    });
  },
  searchLeads({ workspace_id, keyword }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/references/leads/${workspace_id}`,
      params: {
        keyword,
      },
    });
  },
  searchContacts({ workspace_id, keyword }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/references/contact/${workspace_id}`,
      params: {
        keyword,
      },
    });
  },
  searchUsers({ keyword }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: '/api/references/users/sales',
      params: {
        keyword,
      },
    });
  },
  get_leads({
    workspace_id,
    step_key,
    offset,
    search,
    filter_type,
  }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}`,
      params: {
        step_key,
        offset,
        search,
        filter_type,
      },
    });
  },
  get_leads_detail({ workspace_id, id }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}/${id}`,
    });
  },
  get_logs({ workspace_id, id }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/logs/${workspace_id}/${id}`,
    });
  },
  create_leads({ workspace_id, data }) {
    return api({
      method: 'post',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}`,
      data,
    });
  },
  update_leads({ workspace_id, id, data }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}/${id}`,
      data,
    });
  },
  update_step_leads({ workspace_id, id, data }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}/${id}/step`,
      data,
    });
  },
  delete_leads({ workspace_id, id }) {
    return api({
      method: 'delete',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}/${id}`,
    });
  },
  complete_leads({ workspace_id, id, data }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/${workspace_id}/${id}/complete`,
      data,
    });
  },
  get_completed_leads(workspace_id, data) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/history/leads/${workspace_id}`,
      params: data,
    });
  },
  get_schedules_by_id(workspace_id, id) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/schedule/${workspace_id}/detail/${id}`,
    });
  },
  get_schedule(workspace_id, data) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/schedule/${workspace_id}/list`,
      params: data,
    });
  },
  create_schedule({ workspace_id, data }) {
    return api({
      method: 'post',
      baseURL: config.api.leadsUrl,
      url: `/api/schedule/${workspace_id}`,
      data,
    });
  },
  update_schedule({ workspace_id, id, data }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/schedule/${workspace_id}/${id}`,
      data,
    });
  },
  delete_schedule(workspace_id, id) {
    return api({
      method: 'delete',
      baseURL: config.api.leadsUrl,
      url: `/api/schedule/${workspace_id}/${id}`,
    });
  },
  download(workspace_id, data) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/history/leads/${workspace_id}/download`,
      params: data,
    });
  },
  searchConversations({ workspace_id, keyword }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/references/conversations/${workspace_id}`,
      params: {
        keyword,
      },
    });
  },
  searchCall({ workspace_id, keyword }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/references/call/${workspace_id}`,
      params: {
        keyword,
      },
    });
  },
  uploadAttachment({ id, workspace_id, data }) {
    return api({
      method: 'post',
      baseURL: config.api.leadsUrl,
      url: `/api/settings/steps/${workspace_id}/${id}/dynamic-file`,
      data,
    });
  },
  getComments({
    workspace_id,
    leads_id,
  }) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/comment/${workspace_id}/${leads_id}/list`,
    });
  },
  createComment({ workspace_id, leads_id, comment }) {
    return api({
      method: 'post',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/comment/${workspace_id}/${leads_id}/create`,
      data: {
        comment,
      },
    });
  },
  updateComment({
    workspace_id,
    leads_id,
    id,
    comment,
  }) {
    return api({
      method: 'patch',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/comment/${workspace_id}/${leads_id}/${id}/update`,
      data: {
        comment,
      },
    });
  },
  deleteComment({ workspace_id, leads_id, id }) {
    return api({
      method: 'delete',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/comment/${workspace_id}/${leads_id}/${id}/delete`,
    });
  },
  getMentionComments(workspace_id) {
    return api({
      method: 'get',
      baseURL: config.api.leadsUrl,
      url: `/api/manage/board/comment/${workspace_id}/mention-list`,
    });
  },
};
